module.exports = __webpack_public_path__ + "media/photos/term-bg-3-14d2f4f2.jpg";